import { createTopic, ConfigActions } from '../lib';
import { z } from 'zod';

const entityNavigatedEventSchema = z.object({
  entityRef: z
    .string()
    .describe('The reference name for this system or component.'),
});

export type EntityNavigatedEvent = z.infer<typeof entityNavigatedEventSchema>;

export const entityNavigatedTopic = createTopic<EntityNavigatedEvent>(
  {
    namespace: 'catalog',
    name: 'entity-navigated',
    description: 'A system/component has been navigated',
  },
  entityNavigatedEventSchema,
  s => [{ action: ConfigActions.HASH, path: s.entityRef }],
);
